import { render, staticRenderFns } from "./t-form-tab.vue?vue&type=template&id=c37f127a&"
import script from "./t-form-tab.vue?vue&type=script&lang=js&"
export * from "./t-form-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports